import styled, { css } from 'styled-components'

type StyledListElementProps = {
  progress: number
}

type StyledListProps = {
  isEmpty?: boolean
}

export const Element = styled.li<StyledListElementProps>`
  position: relative;
  padding: 5px;
  display: flex;
  align-items: center;
  column-gap: 10px;
  border-radius: 10px;

  background-color: var(--bar-color);

  &:before {
    position: absolute;
    left: 0;
    top: 0;
    content: '';
    width: calc(${({ progress }) => progress}% + 20px);
    height: 100%;
    border-radius: 10px;
    background-color: var(--progress-bar-color);
  }
`

export const Marker = styled.span`
  width: 40px;
  border-radius: 5px;
  background-color: var(--marker-color);
  text-align: center;
  font-family: coolvetica, Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: #e4fbf4;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`

export const Label = styled.span`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.black[20]};
  z-index: 1;
`

export const Placeholder = styled.div`
  height: 12px;
  width: 100%;
  border-radius: 30px;
  background: #edeff3;
`

export const List = styled.ol<StyledListProps>`
  --bar-color: #e4fbf4;
  --progress-bar-color: #c1f6e4;
  --marker-color: #37e2a9;
  position: relative;
  display: flex;
  flex-direction: column;
  row-gap: 5px;

  ${({ isEmpty, theme }) =>
    isEmpty &&
    css`
      ${Element} {
        background: #f9fafb;
      }

      ${Marker} {
        background-color: #edeff3;
        color: ${theme.palette.white};
      }
    `}
`
